import React, { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import useUpdateEffect from '../../libraries/hooks/useUpdateEffect';
import { Form, Field } from 'react-final-form';
import FormLayout from '../../components/forms/FormLayout';
import TextInput from '../../components/forms/TextInput';
import TextareaInput from '../../components/forms/TextareaInput';
import Icon from '../../libraries/icons';
import AttachImage from '../../components/forms/AttachImage';
import Button from '../../components/commons/Button';
import Loader from '../../components/commons/Loader';
import { validateIsfilled, selectGeneratorWObjChild, getOwner, getObjectWithJsonDataToFormValues } from '../../libraries/utils';
import messageActions from '../../context/messages/actions';
import filesActions from '../../context/files/actions'
import userActions from '../../context/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, notify } from '../../libraries/notifications';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import LayoutSmall from '../../components/layout/LayoutSmall';
import config from '../../config';
import UserMessageHeader from '../../components/customs/UserMessageHeader';
import appointmentsActions from '../../context/appointments/actions';

import { history } from '../../routes';
class ComposerClass extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      messages: [],
      files: {},
      message: null,
      loading:null, 
      preview:null,
      attachedImage:null
    };
    this.breadcrumbs = [this.t('Messages')];
  }

  componentDidMount() {
    this.getProfessional()
  }

  getProfessional = async () => {
    const params = this.props.match.params;
    if (params.professional_id) {
      await this.props.getUser({ id: params.professional_id })
      const error = this.props.user.error;
      if (error) { 
        notify(this.t(error.message));
      } else {
        const professionalData = getObjectWithJsonDataToFormValues(
          this.props.user.item,
          ['id', 'first_name', 'last_name', 'cover_image', 'profile_image', 'specialty', 'username', 'description', 'accounts', 'name', 'bio']
        );
        this.setState({ professional: professionalData });
      }

    }
  }

  onSubmit = async (values, form) => {
    const { attachedImage,  } = this.state

    let appointment_id = null
    const appointment_data = {
      type: "message", //fixme: cambiar tipo
      sub_type: "message",
      status: "unpaid",
      //date: utcDate,
      source: this.state.professional.id,//getOwner(professional), //get owner id usuario medico
      target: this.props.auth.user.id, //id paciente, owner de usuario getOwner(usuario
      owner: config.OWNER.SYSTEM, //variable custom system
      json_data: { 
        
      }
    }
    await this.props.saveAppointment(appointment_data)
    const error = this.props.appointment.error;
    if (error) {
      notify(this.t(error.message));
      return
    } else {
      const appointment = this.props.appointment.item;
      appointment_id = appointment.id
    }



    const message = {
      ...values,
      target: this.state.professional.id,
      source: this.props.auth.user.id,
      parent: 'root',
      type: 'message',
      related_to: appointment_id,
      json_data: {
        deleted_chat_for_source: 0,
        deleted_for_source: 0,
        deleted_chat_for_target: 0,
        unread_messages_for_target: 1,
        unread_messages_for_source: 0
      }
    }
    if (attachedImage) {
      this.uploadImage(message)
    } else {
      await this.props.onSaveOrUpdate(message)
      const error = this.props.message.error;
      if (error) { 
        notify(this.t(error.message));
      } else {
        history.push(config.ROUTES.MESSAGES)
      }
    }
    //form.reset()
    //history.push(config.ROUTES.MESSAGES)
  }
  uploadImage = async (message) => {
    const { attachedImage } = this.state
    const { data } = attachedImage
    let image_identifier = `message_input_${parseInt(Math.random() * 10 ** 9)}`
    data.append('identifier', image_identifier);
    //setMessage(message)
    //this.props.pictureUpload(data)
  }

  required = (value) => {
    return validateIsfilled(value) ? undefined : this.t('This field is required');
  }

  validateForm = (values) => {
    const errors = {};
    errors.subject = this.required(values.subject);
    errors.body = this.required(values.body);
    return errors;
  };

  compose = () => {
    this.setState({ loading: !this.state.loading })
  }

  previewImage = ({ data }) => {
    this.setState({ preview: data })
  }

  cleanPreview = () => {
    this.setState({ preview: null })
  }

  attachImage = () => {
    this.setState({ attachedImage: "" })
  }

  cleanAttach = () => {
    this.setState({ attachedImage: null })
  }

  render() {
    const { loading, preview, attachedImage } = this.state
    const { user, files } = this.props

    return(
    <LayoutSmall
      main={{ className: ""}}
      header={{
        className: "absolute top-0 w-auto z-20 !bg-transparent flex justify-between p-3",
        left: { icon: 'arrow_left', action: () => {history.push(config.ROUTES.HOME)} },
      }}
      container={{ className: "px-0 relative"}}
      // loading = {this.props.user.loading}
      >
        <main className="w-full h-screen">
            <section className="text-primary-content bg-primary text-center px-3 pt-10 pb-12">
                 {(!user.loading && user.item) && <UserMessageHeader professional={user.item} />}
            </section>
            <section className="section-card">
              <ToastContainer />
              {(loading || files.uploading || user.loading) ? <div className='h-full flex'><Loader /></div> :
                <Form
                  initialValues={{}}
                  onSubmit={this.onSubmit}
                  validate={this.validateForm}
                >
                  {({ handleSubmit, form }) => {
                    return (
                      <FormLayout form={form} onSubmit={handleSubmit}>
                        {preview ?
                          <div className='flex h-full absolute bg-white justify-center items-center w-full'>
                            <p className='absolute top-4 left-12'>Preview</p>
                            <button onClick={() => {this.cleanPreview()}}><Icon className="w-5 h-5 absolute top-4 left-6" name='close' /></button>
                            <div className='w-36'><img src={preview?.src} alt="" /></div>
                            <div className='absolute bottom-12 right-4'><Button onClick={() => this.attachImage(preview)} invert icon='paper_clip' title={this.t('Attach')} /></div>
                          </div> :
                          <div>
                            <div className='tabs tabs-boxed p-3'>
                              <h2 className=''>{this.t('Redacta un mensaje')}</h2>
                            </div>
                            <div className="w-full">
                              <Field
                                name="subject"
                                component={TextInput}
                                placeholder={this.t('Título de la consulta')}
                                label={this.t('Título')}
                                readOnly={loading}
                              />
                            </div>
                            <div className="w-full relative">
                              <Field
                                name="body"
                                component={TextareaInput}
                                placeholder={this.t('Escriba su consulta')}
                                label={this.t('Consulta')}
                                readOnly={loading}
                              />
                            </div>
                            <div className='flex justify-between items-center'>
                              <div className='px-4 relative w-14 h-14'>
                                {
                                  attachedImage && <div className='w-14 h-14'>
                                    <img className='w-14 h-14 object-cover border' src={attachedImage.src} alt="" />
                                    <button onClick={() => {this.cleanAttach()}} className='w-14 h-14 bg-black opacity-0 hover:opacity-60 absolute top-0 flex items-center justify-center transition'><Icon className="w-5 h-5 text-white" name='close' /></button>
                                  </div>
                                }
                              </div>
                              <div className='flex justify-end items-center pr-4'>
                                {/* fixme: descomentar para arrelgar subida de imagenes */}
                              {/*
                                <div className='border-r pr-4 mr-4'>
                                  <Field
                                    name="picture"
                                    component={AttachImage}
                                    placeholder={this.t('Send an image')}
                                    inputOnChange={this.previewImage}
                                    readOnly={loading}
                                    noError={true}
                                  />
                              </div>*/}
                                <Button className="btn btn-primary px-8" type='submit' invert icon='arrow_right' title={this.t('Enviar')} />
                              </div>
                            </div>
                          </div>
                        }

                      </FormLayout>
                    );
                  }}
                </Form>
              }

            </section>
        </main>
   
      </LayoutSmall>)
  }
}

const mapStateToProps = (state) => {
    return {
      auth: state.users.auth,
      messages: state.messages.list,
      message: state.messages.current,
      query: state.messages.list.query,
      user: state.users.current,
      files: state.files,
      appointment: state.appointments.current,
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      getUser: (params) => dispatch(userActions.get(params)),
      saveMessage: (params) => dispatch(messageActions.saveOrUpdate(params)),
      onGetAll: (params) => dispatch(messageActions.getAll(params)),
      pictureUpload: (params) => dispatch(filesActions.upload(params)),
      pictureClean: () => dispatch(filesActions.clean()),
      onRemove: (id) => dispatch(messageActions.del(id)),
      onSaveOrUpdate: (params) => dispatch(messageActions.saveOrUpdate(params)),
      saveAppointment: (params) => dispatch(appointmentsActions.saveOrUpdate(params)),
    };
  };
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(ComposerClass));
